import { render, staticRenderFns } from "./AdminWashRequestAddStaffModal.vue?vue&type=template&id=6532f87a&scoped=true"
import script from "./AdminWashRequestAddStaffModal.vue?vue&type=script&lang=js"
export * from "./AdminWashRequestAddStaffModal.vue?vue&type=script&lang=js"
import style0 from "./AdminWashRequestAddStaffModal.vue?vue&type=style&index=0&id=6532f87a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6532f87a",
  null
  
)

export default component.exports